import "core-js/modules/es6.object.assign";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { ActionsColumn } from '../../ActionsColumn';

var resolveOrDefault = function resolveOrDefault(resolver, defaultValue, rowData, extraData) {
  return typeof resolver === 'function' ? resolver(rowData, extraData) : defaultValue;
};

export var cellActions = function cellActions(actions, actionResolver, areActionsDisabled) {
  return function (label, _ref) {
    var rowData = _ref.rowData,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex,
        _ref$column$extraPara = _ref.column.extraParams,
        dropdownPosition = _ref$column$extraPara.dropdownPosition,
        dropdownDirection = _ref$column$extraPara.dropdownDirection,
        property = _ref.property;
    var extraData = {
      rowIndex: rowIndex,
      columnIndex: columnIndex,
      column: column,
      property: property
    };
    var resolvedActions = resolveOrDefault(actionResolver, actions, rowData, extraData);
    var resolvedIsDisabled = resolveOrDefault(areActionsDisabled, rowData && rowData.disableActions, rowData, extraData);
    var renderProps = resolvedActions && resolvedActions.length > 0 ? {
      children: React.createElement(ActionsColumn, {
        items: resolvedActions,
        dropdownPosition: dropdownPosition,
        dropdownDirection: dropdownDirection,
        isDisabled: resolvedIsDisabled,
        rowData: rowData,
        extraData: extraData
      }, label)
    } : {};
    return Object.assign({
      className: css(styles.tableAction),
      isVisible: true
    }, renderProps);
  };
};